import React from 'react';

import { FieldTableContainer } from '../FieldTableContainer';
import { FieldTableHeader } from './components/FieldTableHeader';
import { FieldTableRow } from './components/FieldTableRow';
import { FieldTableTotalRow } from './components/FieldTableTotalRow';
import { IFieldTable2Props } from './types';

import styles from './FieldTable.module.scss';

export const FieldTable2: React.FC<IFieldTable2Props> = ({
  name,
  headerName = '',
  totalName = '',
  columnsNames,
  rows,
  watchRowTitleName,
  firstColumnWidth = 250,
  disabled = false,
  showSumRow = false,
  editableColumn = true,
  totalRowTitle = '',
  readOnly = false,
  reCalculationHandler,
  readonlyArrayIndexes = [],
  readonlyFirstCell,
  recalculateOnChangeRowIndexes 
}) => {
  return (
    <FieldTableContainer>
      <FieldTableHeader
        name={headerName}
        disabled={disabled}
        columnsNames={columnsNames}
        firstColumnWidth={firstColumnWidth}
        editableColumn={editableColumn}
        firstColumnClass={styles.sticky}
      />

      {rows.map((rowItem, index) => (
        <FieldTableRow
          key={rowItem.id}
          name={name}
          rowIndex={index}
          columnsNames={columnsNames}
          watchRowTitleName={watchRowTitleName}
          firstColumnWidth={firstColumnWidth}
          disabled={disabled}
          readOnly={readOnly || readonlyArrayIndexes.includes(index)}
          reCalculationHandler={reCalculationHandler}
          decimalScale={readOnly ? 1 : 2}
          readOnlyFirstCell={readonlyFirstCell}
          recalculateOnChangeRowIndexes={recalculateOnChangeRowIndexes}
        />
      ))}

      {showSumRow && totalName && (
        <FieldTableTotalRow
          totalName={totalName}
          columns={columnsNames}
          disabled={disabled}
          firstColumnWidth={firstColumnWidth}
          totalRowTitle={totalRowTitle}
        />
      )}
    </FieldTableContainer>
  );
};
